import React from 'react';
import { BareFeedTemplate } from '@go-shared/types/feedTemplate';
import { BubbleButton } from '@go-client/components/BubbleUI';

interface FeedEditorFeedsProps {
  currentFeedId: string;
  feeds: BareFeedTemplate[];
  onFeedClick: (id: string) => void;
}

export function FeedEditorFeeds(props: FeedEditorFeedsProps) {
  const { currentFeedId, feeds, onFeedClick } = props;

  return (
    <>
      {feeds.map((feed) => (
        <BubbleButton
          key={feed._id}
          block
          variant="ocean"
          appearance="squared"
          inverse={currentFeedId != feed._id}
          className="text-left"
          onClick={() => onFeedClick(feed._id)}
        >
          {feed.name}
        </BubbleButton>
      ))}
    </>
  );
}
